export const GET_AUTHENTICATION = 'GET_AUTHENTICATION';
export const GET_AUTHENTICATION_LOADING = 'GET_AUTHENTICATION_LOADING';
export const GET_AUTHENTICATION_ERROR = 'GET_AUTHENTICATION_ERROR';

export const GET_USER_AUTHENTICATED = 'GET_USER_AUTHENTICATED';
export const GET_USER_AUTHENTICATED_LOADING = 'GET_USER_AUTHENTICATED_LOADING';
export const GET_USER_AUTHENTICATED_ERROR = 'GET_USER_AUTHENTICATED_ERROR';

export const RECOVERY_PASSWORD = 'RECOVERY_PASSWORD';
export const RECOVERY_PASSWORD_LOADING = 'RECOVERY_PASSWORD_LOADING';
export const RECOVERY_PASSWORD_ERROR = 'RECOVERY_PASSWORD_ERROR';

export const SIGNOUT_USER_AUTHENTICATED = 'SIGNOUT_USER_AUTHENTICATED';
export const SIGNOUT_USER_AUTHENTICATED_LOADING = 'SIGNOUT_USER_AUTHENTICATED_LOADING';
export const SIGNOUT_USER_AUTHENTICATED_ERROR = 'SIGNOUT_USER_AUTHENTICATED_ERROR';

export const AUTHENTICATION_RESET_STATE = 'AUTHENTICATION_RESET_STATE';